import { CustomEvents } from '@powerplay/common';
export class InitializerType {
    ready = false;
    done = false;
    isReady = () => (this.ready && !this.done);
    setReady = () => {
        this.ready = true;
        window.dispatchEvent(new CustomEvent(CustomEvents.loadingProgress));
    };
    setDone = () => {
        this.done = true;
    };
}
//# sourceMappingURL=InitializerType.js.map